import React, { useRef, FC, useState } from 'react'
import PreviousIcon from 'svg/SA/carousel-left-os.svg'
import NextIcon from 'svg/SA/carousel-right-os.svg'
import QuotationMark from 'svg/SA/quotation-mark-large.svg'
import styles from './artistProfile.module.scss'
import { useSelector } from 'react-redux'
import DATA from 'data/artistTestimonials/data.json'
import { getAccountUserID } from '../selectors'
import classNames from 'classnames'
const TestimonialCarousel: FC = () => {
  const accountUserID = useSelector(getAccountUserID)
  const filteredData = DATA.filter((testimony) => testimony.artistId === accountUserID)
  const [current, setCurrent] = useState(0)
  const touchStartX = useRef<number | null>(null)
  const touchEndX = useRef<number | null>(null)

  const next = () => {
    setCurrent((prev) => (prev + 1) % filteredData.length)
  }

  const prev = () => {
    setCurrent((prev) => (prev - 1 + filteredData.length) % filteredData.length)
  }

  const handleDotClick = (index) => {
    setCurrent(index)
  }

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartX.current = e.changedTouches[0].clientX
  }

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    touchEndX.current = e.changedTouches[0].clientX
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const diff = touchStartX.current - touchEndX.current

      if (diff > 50) next()
      else if (diff < -50) prev()
    }
    touchStartX.current = null
    touchEndX.current = null
  }

  if (!filteredData.length) {
    return null
  }
  return (
    <div className={styles.testimonials}>
      <div className={styles.carouselContainer}>
        <div className={styles.quotation}>
          <QuotationMark />
        </div>
        <h4 className={styles.title}>Testimonials</h4>
        <div
          className={styles.carousel}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <button className={styles.nav} onClick={prev}>
            <PreviousIcon />
          </button>

          <div className={styles.slide}>
            <p className={styles.text}>{filteredData[current]?.testimonialBody}</p>
            <p className={styles.byline}>
              <span>{filteredData[current]?.byline}</span>
              <span>{filteredData[current]?.testimonialSource}</span>
            </p>
          </div>

          <button className={styles.nav} onClick={next}>
            <NextIcon />
          </button>
        </div>

        <div className={styles.dots}>
          {filteredData.map((_, idx) => (
            <span
              key={idx}
              className={classNames(
                {
                  [styles.dotActive]: idx === current,
                },
                styles.dot
              )}
              onClick={() => handleDotClick(idx)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TestimonialCarousel
